module.exports = __webpack_public_path__ + "static/media/user-background.01ae61f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/user-background.png
// module id = 821
// module chunks = 110